/**
 * React hook for Firebase Storage service
 */
import { useMemo } from 'react';
import { useFirebaseServices } from '../app/providers/FirebaseProvider';
import { StorageService } from '../lib/storage';

export const useStorageService = () => {
  const { app } = useFirebaseServices();

  const storageService = useMemo(() => {
    if (!app) return null;
    return new StorageService(app);
  }, [app]);

  return storageService;
};
